import {Directive, HostListener} from '@angular/core';
import {NgControl} from '@angular/forms';

@Directive({
  selector: '[appEmailValidator]',
})
export class EmailValidatorDirective {
  private validators: any;
  private asyncValidators: any;
  private hasFocus = false;

  constructor(public formControl: NgControl) {
  }
  @HostListener('blur') blur(eventData: Event) {
    this.hasFocus = false;
    this.formControl.control.setAsyncValidators(this.asyncValidators);
    this.formControl.control.setValidators(this.validators);
    this.formControl.control.updateValueAndValidity();
  }
  @HostListener('focus') focus(eventData: Event){
    this.hasFocus = true;
    this.validators = this.formControl.control.validator;
    this.asyncValidators = this.formControl.control.asyncValidator;
    this.formControl.control.clearAsyncValidators();
    this.formControl.control.clearValidators();
    this.formControl.control.valueChanges
      .filter(() => this.hasFocus)
      .subscribe(() => this.formControl.control.markAsPending());
  }

}



// WEBPACK FOOTER //
// C:/NightKey/CMS/nightkey-cms/src/app/email-validator.directive.ts